<template>
  <div class="about">
    <h1>{{ categoryData.Name }} for {{ categoryData.EventGroup.Name }}</h1>
    <p>Photos</p>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 v-if="showGroupPhoto">
                <v-dialog v-model="showDialogGallery" dark fullscreen>
                  <v-card>
                    <v-toolbar dark>
                      <v-btn icon dark v-on:click="showDialogGallery = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Group Photo</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items></v-toolbar-items>
                    </v-toolbar>
                    <v-layout justify-center>
                      <v-img :src="categoryData.ThumbnailURL" :max-height="windowHeight" :max-width="windowWidth"
                        contain></v-img>
                    </v-layout>
                  </v-card>
                </v-dialog>
                <v-img :aspect-ratio="16 / 9" v-on:click="openGallery" :src="categoryData.ThumbnailURL">
                  <v-layout pa-2 column fill-height class="lightbox white--text">
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                      <div class="subheading">Group Photo</div>
                      <div class="body-1">Click for full size</div>
                    </v-flex>
                  </v-layout>
                </v-img>
              </v-flex>
              <v-flex v-for="event in categoryEventList" :key="event.ID" xs6 sm4 md3 lg3 xl3>
                <v-card v-on:click="navigateRoute('/event/photolist/' + event.ID)">
                  <v-card-title>
                    <div>
                      <span>{{ event.Name }}</span>
                      <br />
                    </div>
                  </v-card-title>
                  <v-img :src="event.ThumbnailURL" v-if="event.showThumbnailURL" aspect-ratio="1"></v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    id: {
      type: String,
      default: "1"
    }
  },
  name: "CategoryPhoto",
  components: {},
  computed: {
    windowWidth: function () {
      return window.innerWidth;
    },
    windowHeight: function () {
      return 0.8 * window.innerHeight;
    }
  },
  data() {
    return {
      showGroupPhoto: false,
      showDialogGallery: false,
      groupImgUrl: "",
      categoryData: {
        ID: 0,
        CreatedAt: "2019-06-15T02:18:04.600131+08:00",
        EditedAt: "2019-06-15T02:18:04.600131+08:00",
        DeletedAt: "",
        Name: "",
        EventGroupID: 0,
        EventGroup: {},
        ThumbnailURL: ""
      },
      groupPhoto: {
        Url: "",
        DownloadUrl: ""
      },
      categoryEventList: []
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize: function () {
      this.showGroupPhoto = false;
      this.showDialogGallery = false;
      axios
        .get("/api/content/category/" + this.id)
        .then(response => {
          this.categoryData = response.data;
          if (this.categoryData.ThumbnailURL != "") {
            this.showGroupPhoto = true;
          }
        })
        .catch(() => { });
      axios
        .get("/api/content/category/" + this.id + "/eventlist?thumbnails=true")
        .then(response => {
          this.categoryEventList = response.data;
          for (let i = 0; i < this.categoryEventList.length; i++) {
            this.categoryEventList[i].showThumbnailURL = false;
            if (this.categoryEventList[i].ThumbnailURL != "") {
              this.categoryEventList[i].showThumbnailURL = true;
            }
          }
          // this.categoryEventList = this.categoryEventList.map(x => {
          //   axios.get("/api/content/event/" + x.ID + "/mediaentrylist")
          //   .then(response => {
          //     if (response.length > 0) {
          //       if (response[0].Url != null && response[0].Url.length > 0) {
          //         x.thumbnailurl = response[0].Url;
          //         x.ShowThumbnail = true;
          //       }
          //     }
          //   })
          //   .catch(() => {})
          // });
          // let groupPhotoList = response.data.filter(x => x.Name == "Group Photo")
          // if (groupPhotoList.length > 0) {
          //   this.loadGroupPhoto(groupPhotoList[0])
          // }
        })
        .catch(() => { });
    },
    navigateRoute: function (newpath) {
      this.$router.push(newpath, () => { });
    },
    openGallery: function () {
      this.showDialogGallery = true;
      this.groupImgUrl = this.groupPhoto.DownloadUrl;
    }
  },
  watch: {
    id: function (newID, oldID) {
      this.initialize();
    }
  }
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>